export const environment = {
    APIEndpoint: "https://quoteapi.uat.mfg.com/api/",
    DynamoDBAPI: "https://quotenetapi.uat.mfg.com/api/",
    s3BaseUrl: "https://quote-assist-demo-videos.s3.us-east-2.amazonaws.com",
    production: false,
    environmentName: 'uat',
    sentry: {
        dsn: "https://b65b7c6a065f48d05be4a14126d091cd@o4507262598316032.ingest.us.sentry.io/4509447313555456",
        environment: 'uat',
        tracesSampleRate: 0.3
    }
}